"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.radius = void 0;
var radius = {
  sm: '4px',
  md: '6px',
  lg: '8px',
  xl: '12px'
};
exports.radius = radius;